import React, { useEffect, useState } from 'react';
import { Font, Document, Page, StyleSheet } from '@react-pdf/renderer';

const registerFonts = async () => {
  Font.register({
    family: 'GlobalFont',
    fonts: [
      // KR
      {
        src: require('static/fonts/notosanskr/NotoSansKR-Regular.ttf'),
        fontStyle: 'normal',
        fontWeight: 400,
      },
      {
        src: require('static/fonts/notosanskr/NotoSansKR-Medium.ttf'),
        fontStyle: 'normal',
        fontWeight: 500,
      },
      {
        src: require('static/fonts/notosanskr/NotoSansKR-Bold.ttf'),
        fontStyle: 'normal',
        fontWeight: 700,
      },
      // JP
      {
        src: require('static/fonts/notosansjp/NotoSansJP-Regular.ttf'),
        fontStyle: 'normal',
        fontWeight: 400,
      },
      {
        src: require('static/fonts/notosansjp/NotoSansJP-Medium.ttf'),
        fontStyle: 'normal',
        fontWeight: 500,
      },
      {
        src: require('static/fonts/notosansjp/NotoSansJP-Bold.ttf'),
        fontStyle: 'normal',
        fontWeight: 700,
      },
      // ZH
      {
        src: require('static/fonts/notosanszh/NotoSansTC-Regular.ttf'),
        fontStyle: 'normal',
        fontWeight: 400,
      },
      {
        src: require('static/fonts/notosanszh/NotoSansTC-Medium.ttf'),
        fontStyle: 'normal',
        fontWeight: 500,
      },

      {
        src: require('static/fonts/notosanszh/NotoSansTC-Bold.ttf'),
        fontStyle: 'normal',
        fontWeight: 700,
      },
      {
        src: require('static/fonts/notosanszh/NotoSansSC-Regular.ttf'),
        fontStyle: 'normal',
        fontWeight: 400,
      },
      {
        src: require('static/fonts/notosanszh/NotoSansSC-Medium.ttf'),
        fontStyle: 'normal',
        fontWeight: 500,
      },

      {
        src: require('static/fonts/notosanszh/NotoSansSC-Bold.ttf'),
        fontStyle: 'normal',
        fontWeight: 700,
      },
      // Arabic
      {
        src: require('static/fonts/notosansar/NotoSansArabic-Regular.ttf'),
        fontStyle: 'normal',
        fontWeight: 400,
      },
      {
        src: require('static/fonts/notosansar/NotoSansArabic-Medium.ttf'),
        fontStyle: 'normal',
        fontWeight: 500,
      },

      {
        src: require('static/fonts/notosansar/NotoSansArabic-Bold.ttf'),
        fontStyle: 'normal',
        fontWeight: 700,
      },
    ],
    // subsets: false, // 서브셋 생성 방지
  });
};

const styles = StyleSheet.create({
  page: {
    fontFamily: 'GlobalFont',
    border: 'none',
    backgroundColor: '#fff',
    width: '100%',
    paddingBottom: 45,
  },
});

interface ProductionRequestPdfDocumentProps {
  pdf: any;
}
const ProductionRequestPdfDocument = ({ pdf }: ProductionRequestPdfDocumentProps) => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    registerFonts().then(() => setFontsLoaded(true));
  }, []);

  if (!fontsLoaded) return <div>Loading Fonts...</div>;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {pdf}
      </Page>
    </Document>
  );
};

export default React.memo(ProductionRequestPdfDocument);
